import DirectionsRunIcon from '@mui/icons-material/DirectionsRun';
import KeyboardArrowRightRoundedIcon from '@mui/icons-material/KeyboardArrowRightRounded';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import { Box, Button, ButtonBase, Typography, type SxProps } from '@mui/material';
import { flatSx } from '@ocodelib/mui';
import clsx from 'clsx';
import type { ReactNode } from 'react';
import React from 'react';
import { LinkI18n } from '../i18n/routing';

interface Props {
  sx?: SxProps;
  className?: string;
  language: string; // js,py,p5
  logo?: ReactNode;
  title?: ReactNode;
  subtitle?: ReactNode;
  href: string;
  tutorHref?: string;
  tint: string;
  textColor: string;
  bottomBtnColor?: string;
  onClickLectureBtn: React.MouseEventHandler;
}

export function CodingListRow(props: Props) {
  const {
    sx,
    className,
    title,
    subtitle,
    logo,
    tint,
    textColor,
    href,
    tutorHref,
    bottomBtnColor,
    onClickLectureBtn,
  } = props;

  return (
    <Box
      className={clsx('CodingListRow-root', className)}
      component="div"
      sx={flatSx(
        {
          position: 'relative',
          maxWidth: 400,
          mx: 'auto',
          display: 'flex',
          justifyContent: 'flex-start',
          flexDirection: 'column',
          width: '100%',
          borderRadius: '10px',
          border: '1px solid #ddd',
          overflow: 'hidden',
          flexWrap: 'nowrap',
        },
        sx,
      )}
    >
      <ButtonBase
        className="CodingListRow-topBox"
        LinkComponent={LinkI18n}
        href={href}
        sx={{
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          alignItems: 'flex-start',
          lineHeight: 0,
          width: '100%',
          height: 236,
          py: 2,
          px: 4,
          bgcolor: tint,
          color: textColor,
        }}
      >
        <KeyboardArrowRightRoundedIcon
          className="CodingListRow-detailIndicator"
          sx={{
            position: 'absolute',
            color: textColor,
            top: 42,
            right: 25,
          }}
        />
        {logo}
        <Typography
          sx={{
            mt: 2,
            fontSize: '1.6rem',
            fontWeight: 700,
            color: textColor,
          }}
        >
          {title}
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: textColor,
          }}
        >
          {subtitle}
        </Typography>
      </ButtonBase>
      <Box
        sx={{
          position: 'absolute',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          left: 0,
          bottom: 0,
          px: 2,
          py: 1,
          width: '100%',
          overflow: 'hidden',
          backgroundColor: '#fff',
        }}
      >
        <Button
          startIcon={<MenuBookIcon />}
          color="inherit"
          onClick={onClickLectureBtn}
          sx={{
            color: bottomBtnColor ? bottomBtnColor : tint,
            fontSize: '0.875rem',
          }}
        >
          기초학습
        </Button>
        <Button
          startIcon={<DirectionsRunIcon />}
          LinkComponent={LinkI18n}
          disabled={!tutorHref}
          href={tutorHref}
          sx={{
            color: bottomBtnColor ? bottomBtnColor : tint,
            fontSize: '14px',
          }}
        >
          튜터
        </Button>
      </Box>
    </Box>
  );
}
